<template>
    <div class="AlternativeDetailsComponent">
        <b-button @click="back" :variant="variant" size="sm" class="btn button-back">{{lang.button_Back}}</b-button>
        <b-button v-if="currentUser.role != 'Reader'" @click="unassign" :variant="variant" size="sm"
            class="btn button-unassign">{{lang.button_Unassign}}
        </b-button>
        <b-button v-if="currentUser.role != 'Reader'" @click="sync" :variant="variant" size="sm" class="btn button-sync"
            :disabled="byUser">
            <b-spinner v-show="isSpinner" small></b-spinner> {{lang.button_Sync}}
        </b-button>
        <AlternativeDetailsMainTableComponent :lang="lang.OverallDetails"></AlternativeDetailsMainTableComponent>
        <AlternativeDetailsPropTableComponent :lang="lang.PropertiesDetails"></AlternativeDetailsPropTableComponent>
        <SearchedDetailsAvailabilityTableComponent :lang="lang.AvailabilityDetails">
        </SearchedDetailsAvailabilityTableComponent>
        <AlternativeDetailsPriceTableComponent :lang="lang.PriceDetails"></AlternativeDetailsPriceTableComponent>

        <div>
            <hr>
            <label for="endoflife-datepicker">{{lang.label_EndOfLife}}:</label>
            <b-form-datepicker :disabled="currentUser.role == 'Reader'" id="endoflife-datepicker" v-model="endoflife"
                :state="endoflifeState" size="sm" class="mb-1"></b-form-datepicker>
            <label for="endofsale-datepicker">{{lang.label_EndOfSale}}:</label>
            <b-form-datepicker :disabled="currentUser.role == 'Reader'" id="endofsale-datepicker" v-model="endofsale"
                :state="endofsaleState" size="sm" class="mb-1"></b-form-datepicker>
            <label for="comment-textarea">{{ lang.label_Comment}}:</label>
            <b-form-textarea id="comment-textarea" class="item-form comment-textarea mb-1" :rows="6" v-model="comment"
                :disabled="currentUser.role == 'Reader'" size="sm">
            </b-form-textarea>
            <b-button v-if="currentUser.role != 'Reader'" @click="endofpart" :variant="variant" size="sm"
                class="btn button-update">{{lang.button_Update}}
            </b-button>

        </div>
        <div v-if="globalSettings.SEDetails">
            <hr>
            <SearchedSEDetailsTableComponent :lang="lang.SEDetails" parent="parts"></SearchedSEDetailsTableComponent>


        </div>
        <br>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import AlternativeDetailsMainTableComponent from '@/components/shared/AlternativeDetailsMainTableComponent'
import AlternativeDetailsPropTableComponent from '@/components/shared/AlternativeDetailsPropTableComponent'
import AlternativeDetailsPriceTableComponent from '@/components/shared/AlternativeDetailsPriceTableComponent'
import SearchedDetailsAvailabilityTableComponent from '@/components/shared/SearchedDetailsAvailabilityTableComponent'
import SearchedSEDetailsTableComponent from '@/components/shared/SearchedSEDetailsTableComponent'

export default {
name: 'AlternativeDetailsComponent',
props:{
lang: Object
},
components: {
    AlternativeDetailsMainTableComponent,
    AlternativeDetailsPropTableComponent,
    AlternativeDetailsPriceTableComponent,
    SearchedDetailsAvailabilityTableComponent,
    SearchedSEDetailsTableComponent

},
data () {
    return {
        endoflife: null,
        endofsale: null,
        comment: "",
        endoflifeState: null,
        endofsaleState: null,
        isSpinner: false,
        byUser: false
    }
},
    computed: {
    ...mapGetters({

        globalSettings: "globalSettings",
        currentUser: 'currentUser'
    }),
    variant(){
        if (this.$store.getters.s_skinVariant == "dark"){
            return "light";
        }else{
            return "dark";
        }
    
    },


},
created () {

    let vue = this;

    const obj = {
        distributorPartId: this.$store.getters.selectedAlternative.distributorPartId
    }

     this.$store.dispatch("getPhysicalParam", obj)
    .then((result) => {
        console.log(result.data)

        vue.endoflife = result.data[0].endOfLife;
        vue.endofsale = result.data[0].endOfSale;  
        vue.comment = result.data[0].comment;

        vue.checkDateEndOfParts();


    })


    this.$store.dispatch("getPhysicalDetails", obj)
    .then((result) => {
        console.log(result.data)
       
        vue.byUser = result.data.Main[0].ByUser;


    })

},
watch: {
value: function (newVal, oldVal) {


}
},
updated() {



},
mounted: function () {

},
methods: {
    back(){
        

        this.$store.dispatch("unselectAlternative");
    },
    unassign(){

        let alert_success_unassignAlternative = this.lang.alert_success_unassignAlternative;
        let alert_error_unassignAlternative = this.lang.alert_error_unassignAlternative;

        let unassignParts = function(_vue){
            let obj = {
                partId: _vue.$store.getters.selectedRows[0].col___revisionId.partId,
                alternatives: [{
                    distributorPartId: _vue.$store.getters.selectedAlternative.distributorPartId
                }]
            }
            
            _vue.$store.dispatch("unassignPhysicals", obj)
            .then((result) => {

                console.log(result)
                if (result.status == "OK"){
                //alert
                    if (result.data == 1){

                        _vue.$store.dispatch("unselectAlternative");
                        const reloadObj = {
                            status: true,
                            name: "AlternativesTableComponent"
                        }
                        _vue.$store.dispatch("reloadAfterActionComplex", reloadObj);

                        const obj = {
                        text: alert_success_unassignAlternative,
                        time: 5,
                        type: "success"
                        }

                        _vue.$store.dispatch("displayFooterAlert", obj);
                    }else{
                        const obj = {
                        text: alert_error_unassignAlternative,
                        time: 15,
                        type: "danger"
                        }

                        _vue.$store.dispatch("displayFooterAlert", obj);
                    }


                }
            })
            

        }
                
        const obj = {
            title: this.lang.alert_Title,
            text: this.lang.alert_Text,
            type: "withdraw",
            buttons: 2,
            size: "sm",
            funcYes: unassignParts,
            funcNo: "",

        }

        this.$store.dispatch("showAlert", obj);
    },
    endofpart(){

        let _vue = this;

        const obj = {
           
            distributorPartId: _vue.$store.getters.selectedAlternative.distributorPartId,
            params: {
                endOfLife: this.endoflife,
                endOfSale: this.endofsale,
                comment: this.comment
            }
        }
        

        this.$store.dispatch("pm_updatePhysicalParam", obj)
            .then((result) => {

                if (result.data == 1){

                    _vue.checkDateEndOfParts();

                    const obj = {
                        text: _vue.lang.alert_success_updateAlternative,
                        time: 5,
                        type: "success"
                    }

                    _vue.$store.dispatch("displayFooterAlert", obj);
                }else{

                    const obj = {
                        text: _vue.lang.alert_error_updateAlternative,
                        time: 15,
                        type: "danger"
                    }

                    _vue.$store.dispatch("displayFooterAlert", obj);
                }

            })


    },
    checkDateEndOfParts(){

        const now = new Date();
        const oneDay = 1000 * 60 * 60 * 24;

        

        if (this.endoflife != null){
            const endoflifeDate = new Date(this.endoflife)
            const diffInTimeA = endoflifeDate.getTime() - now.getTime();
            const diffInDaysA = Math.round(diffInTimeA / oneDay);
            
            if (diffInDaysA < 365){
                this.endoflifeState = false;
            }else{
                this.endoflifeState = true;
            }
        } else {
            this.endoflifeState = null;
        }

        if (this.endofsale != null) {

            const endofsaleDate = new Date(this.endofsale)
            const diffInTimeB = endofsaleDate.getTime() - now.getTime();
            const diffInDaysB = Math.round(diffInTimeB / oneDay);

            if (diffInDaysB < 365) {
                this.endofsaleState = false;
            } else {
                this.endofsaleState = true;
            }
        } else {
            this.endofsaleState = null;
        }
        
    },
    sync(){
        let _vue = this;

        this.isSpinner = true;

        let alert_success_syncAlternative = this.lang.alert_success_syncAlternative;
        let alert_error_syncAlternative = this.lang.alert_error_syncAlternative;

        let obj = {
            distributorPartId: this.$store.getters.selectedAlternative.distributorPartId
        }
        
        this.$store.dispatch("pm_syncDistributorPart", obj)
        .then((result) => {

            console.log(result)
            if (result.status == "OK"){
        
                if (result.data == 1){

                    _vue.isSpinner = false;
                    
                    let reloadObj = {
                        status: true,
                        name: "AlternativesTableComponent"
                    }
                    _vue.$store.dispatch("reloadAfterActionComplex", reloadObj);
                    reloadObj = {
                        status: true,
                        name: "AlternativeDetailsMainTableComponent"
                    }
                    _vue.$store.dispatch("reloadAfterActionComplex", reloadObj);
                    reloadObj = {
                        status: true,
                        name: "AlternativeDetailsPropTableComponent"
                    }
                    _vue.$store.dispatch("reloadAfterActionComplex", reloadObj);
                    reloadObj = {
                        status: true,
                        name: "AlternativeDetailsPriceTableComponent"
                    }
                    _vue.$store.dispatch("reloadAfterActionComplex", reloadObj);
                    reloadObj = {
                        status: true,
                        name: "SearchedDetailsAvailabilityTableComponent"
                    }
                    _vue.$store.dispatch("reloadAfterActionComplex", reloadObj);
                            
                    

                    const obj = {
                    text: alert_success_syncAlternative,
                    time: 5,
                    type: "success"
                    }

                    _vue.$store.dispatch("displayFooterAlert", obj);
                }else{
                    const obj = {
                    text: alert_error_syncAlternative + ".",
                    time: 15,
                    type: "danger"
                    }

                    _vue.$store.dispatch("displayFooterAlert", obj);
                }


            } else {
                const obj = {
                    text: alert_error_syncAlternative + ": " + result.message,
                    time: 15,
                    type: "danger"
                }

                _vue.$store.dispatch("displayFooterAlert", obj);
            }
        })
    }


  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
    .AlternativeDetailsComponent{
        .button-back{
            margin: 5px;
        }
        .button-update{
            margin: 5px;
        }
        .button-sync{
            margin: 5px; 
        }
        .form-control{
            font-size: 0.65rem;
        }
        .comment-textarea{
            height: 90px;
        }
    }

</style>



// WEBPACK FOOTER //
// src/components/shared/AlternativeDetailsComponent.vue